module.exports = __webpack_public_path__ + "img/SES_140254102.3e349f15.jpg";